<template>
  <header class="d-d-grid d-g-cols3 dp3-topbar d-ol-none" tabindex="0" id="panelTopBar">
    <div class="d-d-flex d-jc-space-between d-pt12 d-pr8 d-pb8 d-pl16">
      <div class="d-d-flex d-ai-center">
        <router-link to="/" @click.prevent="handleLogoClick">
          <Logo />
        </router-link>
      </div>
      <dt-stack direction="row" gap="400">
        <dt-button v-dt-tooltip:bottom="`Back`" importance="clear" kind="muted" class="dp3-btn--icon-only" disabled>
          <template #icon>
            <dt-icon name="arrow-left" size="400" />
          </template>
        </dt-button>
        <dt-button v-dt-tooltip:bottom="`Forward`" importance="clear" kind="muted" class="dp3-btn--icon-only">
          <template #icon>
            <dt-icon name="arrow-right" size="400" />
          </template>
        </dt-button>
        <dt-button v-dt-tooltip:bottom="`Refresh`" importance="clear" kind="muted" class="dp3-btn--icon-only">
          <template #icon>
            <dt-icon name="refresh" size="400" />
          </template>
        </dt-button>
      </dt-stack>
    </div>
    <div class="d-fl-center d-pt12 d-pb8 dp3-search-launch">
      <SearchBox />
    </div>
    <div class="d-fl-center d-jc-flex-end d-pt12 d-pr16 d-pb8 d-pl8">
      <UserBox />
    </div>
  </header>
</template>

<script setup lang="ts">
import { DtStack, DtButton, DtIcon } from '@dialpad/dialtone/vue3';

import Logo from './DialpadLogo.vue';
import SearchBox from './TopBarSearchBox.vue';
import UserBox from './TopBarUserBox.vue';
import { useDevToolsStore } from '../store/useDevToolsStore';
import { useRouter } from 'vue-router';
import { useDebugLogger } from '../utils/debugLogger';

const router = useRouter();
const devToolsStore = useDevToolsStore();
const debugLogger = useDebugLogger();

/**
 * Handle logo click with special handling for DevTools
 * When SHIFT + CMD/CTRL is pressed, toggle DevTools
 * Otherwise, navigate to home
 */
function handleLogoClick(event: MouseEvent) {
  // Check if SHIFT + CMD/CTRL is pressed
  if (event.shiftKey && (event.metaKey || event.ctrlKey)) {
    // Toggle DevTools
    event.preventDefault();
    devToolsStore.toggle();
    debugLogger.log('🛠️ DevTools toggled via Logo click');
  } else {
    // Normal navigation to home
    router.push('/');
  }
}
</script>
